export enum ActivityPlayerEvent {
  LESSON_COMPLETE = 'lessonComplete',
  ACTIVITY_COMPLETE = 'activityComplete',
  SLIDE_CHANGED = 'slideChanged',
}
